<template>
<div>
  <error-cant-reach-server :errorData="errorData"  class="mt-2 mr-2 ml-2" v-if="isCantReach" @clickCTA="$reloadPage()"></error-cant-reach-server>
  <div class="container text-center">
    <div class="spinner-border text-primary text-center m-4" role="status" v-if="isLoading">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <ul class="list-group list-group-flush">
    <li class="list-group-item p-4" v-for="transaction in transactions" :key="transaction.id">
      <div class="row">
        <div class="col-8">
            <p>
              <template v-if="transaction.type === 'deposit'" class="m-0">ฝากเงินเข้าบัญชี</template>
              <template v-if="transaction.type === 'withdraw'" class="m-0">ถอนเงินออกจากบัญชี</template>
              <template v-if="transaction.type === 'cancel_withdraw'" class="m-0">เงินคืนเนื่องจากการปฏิเสธการถอน</template>
              <template v-if="transaction.type === 'withdraw_fee'" class="m-0">ค่าธรรมเนียมของการถอนเงิน</template>
              <template v-if="transaction.type === 'cancel_withdraw_fee'" class="m-0">เงินคืนค่าธรรมเนียมเนื่องจากการปฏิเสธการถอน</template>
              <template v-if="transaction.type === 'deposit_fee'" class="m-0">ค่าธรรมเนียมของการฝากเงิน</template>

              <template v-if="transaction.type === 'fee'" class="m-0">ค่าธรรมเนียมรักษาบัญชี</template> <!-- DEPRECATED -->
              <template v-if="transaction.type === 'lend'" class="m-0">ให้เงินผู้ขอกู้ตามสัญญา</template>
              <template v-if="transaction.type === 'borrow'" class="m-0">รับเงินกู้จากผู้ให้กู้ตามสัญญา</template>

              <template v-if="transaction.type === 'pay_invoice'" class="m-0">ชำระค่างวดสัญญา </template>
              <template v-if="transaction.type === 'receive_pay_invoice'" class="m-0">รับค่างวดสัญญา</template>

              <template v-if="transaction.type === 'pay_down_payment'" class="m-0">จ่ายเงินดาวน์</template>
              <template v-if="transaction.type === 'receive_down_payment'" class="m-0">รับเงินดาวน์จากสัญญาซื้อขาย</template>

              <template v-if="transaction.type === 'contract_fee'" class="m-0">ค่าธรรมเนียมการทำสัญญา</template>
              <template v-if="transaction.type === 'lender_fee'" class="m-0">ค่าธรรมเนียมผู้ให้กู้</template>

              <template v-if="transaction.type === 'view_credit_bureaus_fee'" class="m-0">ค่าธรรมเนียมประวัติเครดิต</template>
              
              <template v-if="transaction.type === 'print_transaction_three_month_fee'" class="m-0">ค่าธรรมเนียมการขอสเตจเม้นท์ 3 เดือน</template>
              <template v-if="transaction.type === 'print_transaction_six_month_fee'" class="m-0">ค่าธรรมเนียมการขอสเตจเม้นท์ 6 เดือน</template>
              <template v-if="transaction.type === 'print_transaction_twelve_month_fee'" class="m-0">ค่าธรรมเนียมการขอสเตจเม้นท์ 12 เดือน</template>

              <span v-if="transaction.invoice !== null"> ({{transaction.invoice.period}}/{{transaction.invoice.totalPeriod}})</span>
              <span v-if="transaction.contractNo !== null"> #{{transaction.contractNo}}</span>
            </p>
            <p class="m-0 text-secondary" v-if="
              transaction.type === 'lend' ||
              transaction.type === 'borrow' ||
              transaction.type === 'pay_invoice' ||
              transaction.type === 'receive_pay_invoice' ||
              transaction.type === 'pay_down_payment' ||
              transaction.type === 'receive_down_payment'">
              <small v-if="transaction.type === 'lend' || transaction.type === 'pay_invoice' || transaction.type === 'pay_down_payment'">จ่ายให้ {{transaction.party_name}}</small>
              <small v-if="transaction.type === 'borrow' || transaction.type === 'receive_pay_invoice' || transaction.type === 'receive_down_payment'">รับจาก {{transaction.party_name}}</small>
            </p>
        </div>
        <div class="col-4 text-right">
            <p v-if="
              transaction.type === 'withdraw' ||
              transaction.type === 'fee' ||
              transaction.type === 'lend' ||
              transaction.type === 'pay_invoice' ||
              transaction.type === 'pay_down_payment' ||
              transaction.type === 'contract_fee' ||
              transaction.type === 'lender_fee' ||
              transaction.type === 'withdraw_fee' ||
              transaction.type === 'deposit_fee' ||
              transaction.type === 'view_credit_bureaus_fee' ||
              transaction.type === 'print_transaction_three_month_fee' || 
              transaction.type === 'print_transaction_six_month_fee' || 
              transaction.type === 'print_transaction_twelve_month_fee'" class="m-0 text-danger">{{ transaction.amount | money }}</p>
            <p v-else-if="transaction.type === 'cancel_withdraw' ||  transaction.type === 'cancel_withdraw_fee'" class="m-0 text-primary">{{ transaction.amount | money }}</p>
            <p v-else class="m-0 text-success">{{ transaction.amount | money }}</p>
            <p class="m-0 text-secondary"><small>{{ $dayjs(transaction.datetime).format('HH:mm D MMM YYYY') }}</small></p>
        </div>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
import SearchBar from '../../sub_components/SearchBar'

export default {
  data: () => ({
    isCantReach: false,
errorData: {},
    isLoading: false,
    transactions: [],
  }),
  async created () {
    this.transactions = []
    this.isLoading = true
    const result = await this.$api.transaction.list()
    const data = result.data
    if (!data.success) {
      this.isCantReach = true
this.errorData = data
      return
    }
    this.transactions = data.transactions
    this.isLoading = false
  },
  props: ['activeUserSide'],
  components: {
    SearchBar
  }
}
</script>

<style lang="scss">
</style>
